import { SidebarCssProviderBase } from '@lmnop/web-core';

export class WebsiteSidebarCssProvider extends SidebarCssProviderBase {
    public getBaseCssFiles(): string[] {
        return ['assets/content-script-styles.css', 'assets/content-script-vendor.css', 'assets/all.css', 'assets/bootstrap.css', 'assets/jquery-ui.css'];
    }
}
